export default __webpack_public_path__ + "static/media/cloudfile.d682983e.svg";